(() => {
  if (window.__cpCartRecoveryUIInstalled) return;
  window.__cpCartRecoveryUIInstalled = true;
  const root = document.querySelector('cart-drawer.cp-owned-cart');
  if (!root) return;
  let processing = false;
  const labels = () => {
    const german = document.documentElement.lang.toLowerCase().startsWith('de');
    const result = { retry: german ? 'Erneut prüfen' : 'Check again', remove_box: german ? 'Diese Drinkbox entfernen' : 'Remove this drink box' };
    try {
      const data = JSON.parse(root.querySelector('[data-cp-cart-recovery-labels]')?.textContent || '{}');
      for (const key of Object.keys(result)) if (typeof data[key] === 'string' && data[key].trim()) result[key] = data[key];
    } catch {}
    return result;
  };
  const update = () => {
    const host = root.querySelector('#CartDrawer-CartErrors');
    if (!host) return;
    const pending = window.__cpDrinkboxDepositRecoveryPending;
    let controls = host.querySelector('[data-cp-deposit-recovery]');
    if (!pending) { controls?.remove(); return; }
    if (!controls) {
      controls = document.createElement('div');
      controls.setAttribute('data-cp-deposit-recovery', '');
      const status = document.createElement('p');
      status.setAttribute('role', 'status');
      status.textContent = pending.message || '';
      controls.append(status);
      const copy = labels();
      for (const [method, label] of [['reconcile', copy.retry], ['abortScoped', copy.remove_box]]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'button button--secondary';
        button.textContent = label;
        button.addEventListener('click', async () => {
          if (processing) return;
          processing = true;
          update();
          try {
            const recovery = window.CandyPeakDrinkboxRecovery;
            if (typeof recovery?.[method] !== 'function') throw new Error(pending.message || window.cartStrings?.error || '');
            await recovery[method]();
            await window.CandyPeakOwnedCart.refresh();
          } catch (error) {
            const currentStatus = root.querySelector('[data-cp-deposit-recovery] p');
            if (currentStatus) { currentStatus.setAttribute('role', 'alert'); currentStatus.textContent = error?.message || pending.message || ''; }
          } finally { processing = false; update(); }
        });
        controls.append(button);
      }
      host.append(controls);
    }
    controls.querySelectorAll('button').forEach(button => { button.disabled = processing; });
  };
  for (const name of ['cp:drinkbox-deposit-pending', 'cp:drinkbox-deposit-resolved', 'cp:cart:updated', 'cp:cart:opened']) document.addEventListener(name, update);
  new MutationObserver(records => {
    if (records.some(record => record.target.id === 'CartDrawer-CartErrors' || [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'CartDrawer-CartErrors' || node.querySelector?.('#CartDrawer-CartErrors'))))) update();
  }).observe(root, { childList: true, subtree: true });
  update();
})();
